import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function usePinData() {
  const { cb, key } = fetch();

  const { data, isLoading, isSuccess, isError, refetch } = useQuery(key, cb, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    cacheTime: Infinity,
  });

  return {
    pinData: data?.result,
    isLoading,
    isSuccess,
    isError,
    refetch,
  };
}

export { usePinData };
export default { usePinData };
